import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, DumbbellIcon, UtensilsIcon, CheckSquareIcon, SparklesIcon } from 'lucide-react';
const deliverables = [{
  title: 'Guía Maestra Rutina Bio-Fitness',
  desc: 'El manual paso a paso para entender tus 4 estaciones.',
  icon: BookOpenIcon
}, {
  title: 'Protocolo de Entrenamiento ERBF',
  desc: 'Qué ejercicios hacer y cuándo bajar la intensidad.',
  icon: DumbbellIcon
}, {
  title: 'Matriz de Nutrición Ciclo-Sincrónica',
  desc: 'Qué comer en cada fase para eliminar antojos.',
  icon: UtensilsIcon
}, {
  title: 'Checklist Antinflamatorio',
  desc: 'Acciones diarias para reducir la hinchazón abdominal.',
  icon: CheckSquareIcon
}, {
  title: 'Guía de Suplementación Estratégica',
  desc: 'Magnesio, Omega 3 y adaptógenos según tu día del ciclo.',
  icon: SparklesIcon
}];
export function WhatYouGetSection() {
  return <section className="py-24 bg-emerald-950 relative" data-id="element-187">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-190">
            LO QUE OBTIENES <span className="text-gradient-gold" data-id="element-191">HOY</span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-192">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <FadeIn key={index} delay={0.1 * index} data-id="element-193">
                <div className="bg-emerald-900/50 border border-emerald-800/50 p-6 md:p-8 rounded-2xl flex flex-col sm:flex-row items-start sm:items-center gap-6 group hover:border-gold-500/30 transition-colors" data-id="element-194">
                  <div className="bg-emerald-950 p-4 rounded-xl border border-emerald-800 group-hover:border-gold-500/50 transition-colors" data-id="element-195">
                    <Icon className="w-8 h-8 text-gold-400" data-id="element-196" />
                  </div>
                  <div data-id="element-197">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-198">
                      {item.title}
                    </h3>
                    <p className="text-emerald-100/70 font-body" data-id="element-199">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}